<script>
  import { onMount } from "svelte";
  import { makeClientWebsiteRequest } from "../Common/tools";
  import {External, M} from "../external";

  export let order = null,
    productId = null;

  export function getSelectedOption() {
    return selectedOption;
  }

  let product = {};

  let selectedVariations = {};
  let selectedOption = {
    productId: productId,
    price: 0,
    quantity: 1,
    additions: []
  };

  let refreshSelectedOption = (updatePrice) => {
    let hasQuantity = false,
      itemPrice = product.price,
      itemOnSalePrice = product.salePrice || 0,
      itemOnSale = product.onSale,
      itemQuantity = product.quantity === "" || product.quantity === null ? null : product.quantity,
      variations = product.variations || [],
      combinations = product.combinations;

    selectedOption.combination = -1;
    selectedOption.variation = [];

    let advancedOptions = [];
    for (let idx = 0; idx < variations.length; ++idx) {
      let variation = variations[idx];
      let value = selectedVariations[variation.name] || "";
      selectedOption.variation.push({
        name: variation.name,
        value: value
      });
      if (variation.advanced) {
        advancedOptions.push(value);
      }
    }

    if (combinations.length === 0) {
      if (updatePrice) {
        selectedOption.price = itemOnSale ? itemOnSalePrice : itemPrice;
      }
      hasQuantity = itemQuantity === null || itemQuantity > 0;
    } else {
      let combinationIdx = -1;
      let advancedVariations = variations.filter((v) => v.advanced).map((v) => v.values);
      External.WebPlatform.cartesianProduct(advancedVariations, function (combination) {
        ++combinationIdx;
        for (let idx = 0; idx < combination.length; ++idx) {
          if (combination[idx] !== advancedOptions[idx]) return true;
        }
        return false;
      });

      let combination = combinations[combinationIdx];
      if (updatePrice) {
        selectedOption.price = combination.onSale ? combination.salePrice : combination.price;
      }
      hasQuantity = combination.quantity === null || combination.quantity > 0;
      selectedOption.combination = combination.combination;
    }
    return hasQuantity;
  };

  onMount(async function () {
    let result = await makeClientWebsiteRequest({
      action: "getStoreProduct",
      data: {
        id: productId
      }
    });
    product = result.data;
    selectedOption.productId = product.id;
    if (product.additions && product.additions.fields && product.additions.fields.length) {
      product.additions.fields.forEach((field) => {
        selectedOption.additions.push({
          name: field.name,
          value: ""
        });
      });
    }

    // give the browser a bit of time to fill-in default options
    setTimeout(() => {
      refreshSelectedOption(true);
    }, 1);
  });
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> invert_colors </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-10 t-center h4-bigger">{product.title}</h4>
  <span class="light-gray-text t-center col20 f-left mb-25 padded-text">{M.SELECT_QTY_VARIATION}</span>

  {#if (product.variations && product.variations.length) || selectedOption.additions.length}
    {#if product.variations && product.variations.length}
      {#each product.variations as variation}
        <div class="popup-input-wrapper f-left" data-name={variation.name}>
          <div class="info">
            <h5>{variation.name}</h5>
          </div>
          <select name={variation.name} class="page-select" bind:value={selectedVariations[variation.name]} on:change={() => refreshSelectedOption(variation.advanced)}>
            {#each variation.values as option}
              <option value={option}>{option}</option>
            {/each}
          </select>
        </div>
      {/each}
    {/if}

    {#if selectedOption.additions.length}
      {#each selectedOption.additions as field}
        <div class="popup-input-wrapper f-left">
          <div class="info">
            <h5>{field.name}</h5>
            <input type="text" bind:value={field.value} />
          </div>
        </div>
      {/each}
    {/if}
  {/if}

  <div class="popup-input-wrapper col9n">
    <h5>
      Product Price {#if product.subscriptionPeriod} / {product.subscriptionPeriod} {/if}
    </h5>
    <input type="number" bind:value={selectedOption.price} min="0" step="0.1" />
  </div>
  <div class="popup-input-wrapper col9n f-right">
    <h5>{M.QUANTITY}</h5>
    <input type="number" bind:value={selectedOption.quantity} min="1" step="1" />
  </div>
</div>
